// Uebersicht fehlender Belege und offener Schritte (mit CSV fuer die Kanzlei). Jeder Eintrag fuehrt direkt zum passenden Arbeitsbereich.
import { useState, useEffect } from "react";
import THEME from "../../../../theme";
import { fs } from "../../utils/styles";
import { belegeApi } from "../../../belege/belegeApi";
import { Karte, Klein, Meldung, Chip, euro, datum } from "../../../belege/ui";

export default function BelegeFehlend({ geheZu }) {
  const [tage, setTage] = useState(14);
  const [u, setU] = useState(null);
  const [fehler, setFehler] = useState("");
  useEffect(() => { belegeApi.uebersichtFehlend(tage).then(setU).catch(e => setFehler(e.message)); }, [tage]);
  if (!u) return <div>{fehler ? <Meldung fehler={fehler} /> : "Lädt…"}</div>;
  return (
    <div>
      <Meldung fehler={fehler} />
      <Karte titel={`Fehlende Belege und offene Schritte (${u.gesamt})`} rechts={
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          <label style={{ color: THEME.colors.textSecondary }}>„offen seit“ ab <input type="number" min="0" max="365" style={{ ...fs.input, width: 70 }} value={tage} onChange={e => setTage(Math.max(0, Math.min(365, parseInt(e.target.value || "0", 10))))} /> Tagen</label>
          <a href={belegeApi.uebersichtCsvUrl(tage)} style={{ ...fs.btn, textDecoration: "none", display: "inline-block" }}>⬇ Liste als CSV (für die Kanzlei)</a>
        </div>}>
        <Klein>Stand {datum(u.stand)}. Die CSV lässt sich in Excel öffnen.</Klein>
      </Karte>
      {Object.entries(u.bereiche).map(([key, b]) => (
        <Karte key={key} titel={`${b.titel} (${b.anzahl})`}>
          <Klein>{b.hinweis}</Klein>
          <div style={{ display: "grid", gap: 6, marginTop: 8 }}>
            {b.eintraege.slice(0, 25).map((e, i) => key === "umsaetze_ohne_beleg" ? (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", gap: 8, flexWrap: "wrap", border: `1px solid ${THEME.colors.border}`, borderRadius: THEME.radius.md, padding: "8px 12px" }}>
                <div>{datum(e.datum)} · {e.partner || "–"}<Klein>{e.verwendungszweck}</Klein></div><strong>{euro(e.offen)}</strong>
              </div>
            ) : key === "amazon_rechnung_fehlt" ? (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", gap: 8, flexWrap: "wrap", border: `1px solid ${THEME.colors.border}`, borderRadius: THEME.radius.md, padding: "8px 12px" }}>
                <div>{e.rechnungsnr || e.bestellnr}<Klein>{datum(e.datum)} · {e.positionen} Position(en)</Klein></div><strong>{euro(e.brutto)}</strong>
              </div>
            ) : (
              <button key={i} onClick={() => geheZu("belege", { beleg: e.id })} style={{ textAlign: "left", cursor: "pointer", background: "transparent", border: `1px solid ${THEME.colors.border}`, borderRadius: THEME.radius.md, padding: "8px 12px", color: THEME.colors.text }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}><span><strong>{e.beleg_nr}</strong> · {e.lieferant || "Lieferant fehlt"}</span><span>{euro(e.brutto)}</span></div>
                <Klein>{datum(e.rechnungsdatum)}{e.info ? ` · fehlt: ${e.info}` : ""} <Chip status={e.status} /></Klein>
              </button>
            ))}
            {b.eintraege.length > 25 && <Klein>… und {b.eintraege.length - 25} weitere (vollständig in der CSV).</Klein>}
            {b.anzahl === 0 && <div style={{ color: THEME.colors.success }}>✔ nichts offen</div>}
          </div>
        </Karte>
      ))}
    </div>
  );
}
